module.exports = __webpack_public_path__ + "static/img/son1_active.57b05744.png";